
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as BadIconComponent } from "./bad-icon.svg";

export const BadIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <BadIconComponent {...props} />;
};
